import React, { useState } from 'react'
import {
    Table,
    Tr,
    Flex,
    PageWrapper,
    PageFooter,
    Th,
    H1WithBack,
} from '../../styling/GlobalStyles'
import { useSelector } from 'react-redux'
import { NavBar } from '../../components/NavBar/NavBar'
import { Pagination } from 'components/Pagination/Pagination'
import { RootState } from 'store'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { convertToDate, getParams, handlePagination } from 'utils/helpers'
import { Td } from 'components/Td/Td'
import useQueryPagination from 'hooks/useQueryPagination'
import { clearTransportationDailyIntents, getTransportationDailyIntents } from 'features/transportation/transportationSlice'
import { transportationDirections } from './TransportationEmployees'
import CalendarInput from 'components/CalendarInput/CalendarInput'

export const TransportationDailyIntents = () => {
    const { dailyIntents } = useSelector((store: RootState) => store.transportation)
    const searchParams = new URLSearchParams(window.location.search);
    const [params, setParams] = useState<any>(getParams({ location, limit: 30, ap: { date: new Date(searchParams.get('date') ?? new Date()) }, localeDateString: true }))

    useQueryPagination({ fetchFunctions: [getTransportationDailyIntents], cleanUpFunctions: [clearTransportationDailyIntents], params })

    const setDate = (value) => { // TODO objediniti funkcije za from i to
        setParams(prev => {
            const copy = structuredClone(prev)
            copy.date = convertToDate(value)
            return copy
        })
    }

    return (
        <>
            <NavBar />
            <PageWrapper>
                <Flex between center mb='16' >
                    <H1WithBack arrow title='Daily Intents' />
                    <CalendarInput
                        maxDate={new Date(params.date)}
                        labelText='Start date'
                        defaultValue={new Date(params.date || new Date())}
                        onChange={v => setDate(v)}
                    />
                </Flex>
                {!dailyIntents?.data?.length ? (
                    <NoItems title='Employees' />
                ) : (
                    <Table>
                        <Th>
                            <Td w='20%' noTooltip text='EMPLOYEE' />
                            <Td w='20%' noTooltip text='ZONE' />
                            <Td w='20%' noTooltip text='ADDRESS' />
                            <Td w='35%' noTooltip text='DIRECTION' />
                            <Td w='5%' />
                        </Th>
                        {
                            dailyIntents.data?.map((item) => {
                                return (
                                    <Tr key={item.id}>
                                        <Td w='20%' text={item.user.firstName + ' ' + item.user.lastName} />
                                        <Td w='20%' text={item?.transportationZone?.name || '/'} />
                                        <Td w='20%' text={item?.transportationZone?.address || '/'} />
                                        <Td w='35%' text={transportationDirections.find(d => d.value == item?.direction)?.label || '/'} />

                                    </Tr>
                                )
                            })}
                    </Table>
                )}
            </PageWrapper>
            <PageFooter>
                <Pagination
                    setPage={(page) => handlePagination(page, setParams, 30)}
                    pageCount={Math.ceil(dailyIntents.totalPages)}
                    forcePage={(params.page ? params.page : 1) - 1}
                />
            </PageFooter>
        </>
    )
}

